module.exports = __webpack_public_path__ + "media/images/lb/720-17469e1cd0702d127e4ab7c96764b67f.svg";